import { TicketProfileLocation } from "./navigation/locations/TicketProfileLocation";
import { NavigationManager } from "./navigation/NavigationManager";
import { CustomerContractProfileLocation } from "./contracts/locations/CustomerContractProfileLocation";
import { TravelConfirmationViewLocation } from "@bookings/BookingHospitality/locations/TravelConfirmationViewLocation";
import { AccommodationConfirmationViewLocation } from "@bookings/BookingHospitality/locations/AccommodationConfirmationViewLocation";

export function registerDirectUrls(manager: NavigationManager) {
  manager.registerDirectUrl(
    "/customer_contracts/:id",
    (params) => new CustomerContractProfileLocation(params.id)
  );

  manager.registerDirectUrl(
    "/dashboard/tickets/:id",
    (params) => new TicketProfileLocation(params.id)
  );

  manager.registerDirectUrl(
    "/bookings/:bookingId/accommodation-confirmation/:confirmationId",
    (params) =>
      new AccommodationConfirmationViewLocation({
        bookingId: params.bookingId,
        confirmationId: params.confirmationId
      })
  );

  manager.registerDirectUrl(
    "/bookings/:bookingId/travel-confirmation/:confirmationId",
    (params) =>
      new TravelConfirmationViewLocation({
        bookingId: params.bookingId,
        confirmationId: params.confirmationId
      })
  );
}
